// Built-in import

import * as React from "react"

import { Paper, Stack, SxProps } from "@mui/material"

import DetailsCard from "./details"
import { IMedia } from "@/types/media"
import { IServerProperty } from "@/store/slices/property"
import { Link } from "react-router-dom"
import PropertyThumbnail from "./details/thumbnail"
import { useMedia } from "@/hook"

// External import


// Internal import







interface ICardProperties {
  item?: IServerProperty
  sxProps?: SxProps
}

const CardProperties: React.FC<ICardProperties> = ({ item, sxProps }) => {
  const background = useMedia(item.media, "background") as IMedia
  const defBackground = useMedia(item.media, "default") as IMedia

  const targetBg = background?.original_url || defBackground?.original_url

  return (
    <Paper
      sx={{
        p: 0,
        position:"relative",
        border: "1px solid",
        borderColor: (t) => t.palette.grey[200],
        borderRadius: 4,
        boxShadow: "0px 0px 10px #99999915",
        overflow: "hidden",
        background: (t) => t.palette.common.white,
        "& img": {
          height: "200px",
          width: "auto",
        },
        ...sxProps
      }}
    >
      {/* image card */}
      <Link to={`show/${item.id as string}`}>
      <Stack
        sx={{
          backgroundColor: (t) => t.palette.common.white,
          borderRadius: 3,
        }}
      >
      </Stack>
      <PropertyThumbnail src={targetBg} />
      </Link>
      {/* description card */}
      <DetailsCard item={item} />
    </Paper>
  )
}

export default CardProperties
